import { configureStore } from '@reduxjs/toolkit'

import tabReducer from './tabs/tabSlice'
import searchReducer from './search/searchSlice'

import { parcelsApi } from './parcels/parcelsApi'

const store = configureStore({
  reducer: {
    search: searchReducer,
    tab: tabReducer,
    [parcelsApi.reducerPath]: parcelsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(parcelsApi.middleware),
})
export default store

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch